export const COMMON_LANDINGS_IMAGES_CDN_PATH = 'https://cdn.lemanapro.ru/lmru/image/upload/q_90,f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/common'

const baseFields = {
  isAvailable: true,
  categoryId: 0,
  presaleType: '',
  presaleSubChannel: '',
  defaultTitle: '',
  description: '',
  otherSection: [],
};

export const KITCHEN_DATA = {
  imageAlt: 'Изображение готовой кухни',
  imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783583646/fudzi/elbrus/images/landings/landings-images/variant-b/kitchen-catalog.jpg/kitchen-catalog.jpg',
  addTitle: 'Кухни',
  url: '/proekt-kuhni/',
  landingName: 'new-kitchen',
  ...baseFields,
  otherSection: ['kitchen-catalog', 'storage', 'bathroom']
};

export const KITCHEN_CATALOGUE_DATA = {
  imageAlt: 'Изображение готовой кухни',
  imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783583646/fudzi/elbrus/images/landings/landings-images/variant-b/kitchen-catalog.jpg/kitchen-catalog.jpg',
  addTitle: 'Каталог готовых кухонь',
  url: '/catalogue/kuhonnye-garnitury/',
  landingName: 'kitchen-catalog',
  ...baseFields,
};

export const STORAGE_DATA = {
  imageAlt: 'Изображение систем хранения',
  imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783583646/fudzi/elbrus/images/landings/landings-images/variant-b/storage.jpg/storage.jpg',
  addTitle: 'Хранение',
  url: '/uslugi/proektirovanie-i-dizayn/sozdayte-vannuyu-komnatu-svoey-mechty/',
  landingName: 'storage',
  ...baseFields,
};

export const BATHHROM_DATA = {
  imageAlt: 'Изображение ванной комнаты',
  imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/v1783583646/fudzi/elbrus/images/landings/landings-images/variant-b/bathroom.jpg/bathroom.jpg',
  addTitle: 'Ванные',
  url: '/uslugi/proektirovanie-i-dizayn/proektirovanie-sistem-hraneniya/',
  landingName: 'bathroom',
  ...baseFields,
};


export const DESIGN_DATA = {
  imageAlt: 'Дизайн-проект помещений',
  imageSrc: 'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/landings-images/design-studio.jpg/design-studio.jpg',
  addTitle: 'Дизайн-проект помещений',
  url: '/uslugi/proektirovanie-i-dizayn/proektirovanie-interera/',
  landingName: 'design-studio',
  ...baseFields,
  otherSection: ['new-kitchen', 'storage', 'bathroom']
};
